import { keysToCamelCase } from "zod-to-camel-case";

import type { Video, VideoCamel } from "@/schema/public/video/video.schema";

export const videoFixture = ({
  overrides = {},
}: {
  overrides?: Partial<Video>;
} = {}): Video => ({
  video_id: 1,
  video_uid: "VIDE-00001-00001",
  mux_playback_id: null,
  signed: false,
  signed_stream_id: null,
  ingest_id: null,
  text_track_id: null,
  caption_id: null,
  title: "",
  description: "",
  url: "",
  _cohort: "0",
  _state: "new",
  _deleted: false,
  video_object: {},
  mux_asset_id: null,
  _release_id: null,
  deprecated_fields: null,
  tpc_media_ids: null,
  tpc_works_ids: null,
  created_at: "2024-02-28T08:09:20.247619+00:00",
  updated_at: "2024-02-28T08:09:20.247619+00:00",
  ...overrides,
});

export const videoFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<VideoCamel>;
} = {}): VideoCamel => ({
  ...keysToCamelCase(videoFixture()),
  ...overrides,
});
